// API Configuration
// In deployed environments, API requests are made to `/api` on the same
// origin (proxied to the upstream by `functions/api/[[path]].js`).
// On localhost we fall back to calling the production API directly so
// local dev works without running a proxy.
const LOCALHOST_FALLBACK_API_BASE_URL = 'https://api.delivyr.net/gui';

const resolveApiBaseUrl = () => {
  if (typeof window === 'undefined') {
    return LOCALHOST_FALLBACK_API_BASE_URL;
  }
  if (window.location.hostname === 'localhost') {
    return LOCALHOST_FALLBACK_API_BASE_URL;
  }
  return `${window.location.origin}/api`;
};

export const API_BASE_URL = resolveApiBaseUrl();

export const API_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: 10000, // 10 seconds
  headers: {
    'Content-Type': 'application/json',
  },
};

export const buildApiUrl = (endpoint, queryParams = {}) => {
  const baseUrl = `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;

  if (Object.keys(queryParams).length === 0) {
    return baseUrl;
  }

  const searchParams = new URLSearchParams();
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      searchParams.append(key, value);
    }
  });

  return `${baseUrl}?${searchParams.toString()}`;
};
